import { nextMonday, nextSaturday, nextSunday, formatISO } from 'date-fns';

const DateChooser = (props) => ({
  open: false,

  showEndDate: props.showEndDate || false,

  startDate: props.startDate ? new Date(props.startDate) : new Date(),

  endDate: props.endDate ? new Date(props.endDate) : new Date(),

  init() {
    this.$watch('startDate', (startDate) => {
      this.$refs.startDateInput.valueAsDate = startDate;
    });

    this.$refs.startDateInput.valueAsDate = this.startDate;

    this.$watch('endDate', (endDate) => {
      this.$refs.endDateInput.valueAsDate = endDate;
    });

    this.$refs.endDateInput.valueAsDate = this.endDate;
  },

  updateSummaryLabel() {
    let label = this.startDate.toLocaleDateString();
    if (this.showEndDate) {
      label += ` — ${this.endDate.toLocaleDateString()}`;
    }

    this.$refs.summaryLabel.textContent = label;
  },

  onToggle() {
    this.open = this.$event.target.open;
  },

  onClickOutside() {
    this.open = false;
  },

  onClickToday() {
    const now = new Date();

    this.startDate = now;
    this.endDate = now;
    this.showEndDate = false;
  },

  onClickThisWeekend() {
    const now = new Date();

    this.startDate = nextSaturday(now);
    this.endDate = nextSunday(now);
    this.showEndDate = true;
  },

  onClickNextWeek() {
    const now = new Date();

    this.startDate = nextMonday(now);
    this.endDate = nextSunday(this.startDate);
    this.showEndDate = true;
  },

  onStartDateInput() {
    this.startDate = this.$event.target.valueAsDate;

    if (this.endDate < this.startDate) {
      this.endDate = this.startDate;
    }
  },

  onEndDateInput() {
    this.endDate = this.$event.target.valueAsDate;
  },

  onToggleShowEndDate() {
    this.showEndDate = !this.showEndDate;
  },

  onSubmit() {
    const url = new URL(window.location.href);

    const startDate = formatISO(this.startDate, { representation: 'date' });
    const endDate = formatISO(this.endDate, { representation: 'date' });

    url.searchParams.set('eventStartDate', startDate);

    if (this.showEndDate) {
      url.searchParams.set('eventEndDate', endDate);
    } else {
      url.searchParams.delete('eventEndDate');
    }

    window.location.href = url;
    // if (typeof window.htmx !== 'undefined') {
    //   window.htmx.ajax('GET', url.toString(), {
    //     target: 'body',
    //     swap: 'outerHTML'
    //   });
    // }

    // this.updateSummaryLabel();
    // this.open = false;
  }
});

export default DateChooser;
